import React, { useEffect, useState, SetStateAction } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import service from "../../../../api/services";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import {
    getGSTByRegion,
    getParams,
    getUniqueObj,
} from "../../../../constants/utils";
import {
    AddInvoiceData,
    SearchProduct,
    ProductData,
    TSearchProduct,
    THandleCalculation,
    InvoicePayload,
} from "./interface";
import { useCalculation } from "./hook/useCalculation";
import { usePreparePayload } from "./hook/usePreparePayload";
import { useEditData } from "./hook/useEditData";
const { AddInventoryOrganism } = organisms;
const AddInventory = () => {
    const navigate = useNavigate();
    const {  handleSearchSelect,handleCalculation } = useCalculation();
    const { addInvoicePayload } = usePreparePayload()
    const {handleEditData} = useEditData()
    const { addToast } = useToasts();
    let params = useParams();
    const [typeValue, setTypeValue] = useState<any>(getParams("isRecognized"));
    let invoiceEditID = params.id || "";
    const [search, setSearch] = useState<string>("");
    const [productData, setProductData] = useState<ProductData[]>([]);
    const [allProductList, setAllProductList] = useState([]);
    const [previewTab, setPreviewTab] = useState(false);
    const [buttonClick, setButtonClick] = useState(false);

    const [invoiceData, setInvoiceData] = useState<AddInvoiceData>({
        invoice_id: "",
        invoice_count: "",
        gst_invoice: null,
        supplier_invoice_number: "",
        supplier_invoice_date: "",
        local_supplier_name:"",
        category: null,
        actual_invoice: "",
        total_srp: "",
        remark: "",
        invoice_file: []
    });

    const getProductData = async (data: string) => {
        try {
            // let response = await service.product.view({ "search": e ,"id":id})
            // let id = invoiceData?.store_id?.value;
            let response = await service.inventory.addInventorySearch({
                search: data,
                // storeId: id,
                is_recognised: typeValue,
            });
            const updateProductKeys: SetStateAction<never[]> =
                response?.data?.data?.map((product: SearchProduct) => {
                    let qty = 1;
                    let tempGstAmount =
                        (product.product_srp *
                            getUniqueObj(
                                product.brand.product_types,
                                "product_type_id",
                                product.product_type_id
                            )?.specx_landing_cost) /
                        100;
                    let tempTotalCostAmount = tempGstAmount * qty;
                    let gst_amount =
                        (tempTotalCostAmount * getGSTByRegion(product?.product_type)) /
                        (100 + getGSTByRegion(product?.product_type));
                    let cost_amount: number | string | any = (
                        (product?.product_srp || 0) *
                        getUniqueObj(
                            product?.brand?.product_types,
                            "product_type_id",
                            product?.product_type_id
                        )?.specx_landing_cost *
                        0.01
                    ).toFixed(2);
                    let total_price = cost_amount * qty;
                    let srp_amount = product?.product_srp * qty;
                    return {
                        ...product,
                        cost_amount,
                        qty,
                        total_price,
                        gst_amount,
                        srp_amount,
                    };
                });

            setAllProductList(updateProductKeys);
        } catch (error) {
            console.error(error);
        }
    };


    const getCount = async () => {
        const payload = {
            category: Number(invoiceData?.category?.value),
            // store_id: invoiceData?.store_id?.value || "",
        };

        try {
            let response: any = await service.inventory.getInvoiceDataCount(payload);
            if (response.status === 200) {
                setInvoiceData({ ...invoiceData, invoice_count: response.data.count });
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getInvoiceDataById = async () => {
        try {
            let response = await service.inventory.getDetailById(invoiceEditID);
            handleEditData({response:response.data.data,
                setProductData,
                setInvoiceData});
        } catch (error) {
            console.error("error", error);
        }
    };

    const addInvoice = async () => {
        let payload:InvoicePayload =  addInvoicePayload({productData,invoiceData})
        try {
            let response: any;
            if (invoiceEditID) {
                response = await service.inventory.edit(invoiceEditID, payload);
            } else {
                response = await service.inventory.add(payload);
            }
            if (response.status === 201) {
                addToast(response?.data?.message, {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                navigate(-1);
            } else if (response?.status === 200) {
                addToast(response?.data?.message, {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                navigate(-1);
            }
        } catch (error: any) {
            addToast(error.response?.data?.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
        setButtonClick(false);
    };

    useEffect(() => {
        if (invoiceEditID) {
            getInvoiceDataById();
        }
    }, [invoiceEditID]);

    useEffect(() => {
        if (!params.id && invoiceData?.category?.value) {
            getCount();
        }
    }, [invoiceData?.category?.value]);

    useEffect(() => {
        if (buttonClick) {
            addInvoice();
        }
    }, [buttonClick]);


    return (
        <Wrapper>
            <AddInventoryOrganism
                search={search}
                setSearch={setSearch}
                productData={productData}
                allProductList={allProductList}
                handleSearchSelect={(response: TSearchProduct) =>
                    handleSearchSelect({
                        response,
                        prevData: productData,
                        setProductData
                    })
                }
                setProductData={setProductData}
                previewTab={previewTab}
                setPreviewTab={setPreviewTab}
                setAllProductList={setAllProductList}
                invoiceData={invoiceData}
                setInvoiceData={setInvoiceData}
                setButtonClick={(e: any) => setButtonClick(e)}
                getProductData={(data: string) => getProductData(data)}
                handleCalculation={({type,id,value}:THandleCalculation)=> handleCalculation({productData,
                    setProductData,
                    type,
                    id,
                    getGSTByRegion,
                    value,})}
            />
        </Wrapper>
    );
};
export default AddInventory;
